module.exports = __webpack_public_path__ + "media/proksee-viewer/images/icon-log-0736093748c24facc2313aeae2eca956.png";